<template>
  <v-content class="mx-4">
    <v-layout v-if="tab == 1">
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">จัดการบัญชีผู้ใช้</span>
        </v-btn>
        <v-icon style="color: #527281">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #527281" @click="$router.push('/manage-user-accounts').catch(err => {})">บัญชีผู้ใช้งานทั้งหมด</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout v-else>
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">จัดการบัญชีผู้ใช้</span>
        </v-btn>
        <v-icon>arrow_right</v-icon>
        <v-btn text class="px-1">
          <span>จัดการหน่วยงาน</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          บัญชีผู้ใช้งานทั้งหมด
        </v-btn>
      </v-flex>
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 2" :class="{active: tab === 2}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          จัดการหน่วยงาน
        </v-btn>
      </v-flex>

      <v-flex style="text-align: right;position: absolute;top:45px;right:60px;">
        <v-btn v-if="tab == 2" class="mr-1" color="#84A2A8"
               @click="$router.push('/add-department').catch(err => {})"
               style="color: white;border-radius: 50px;text-align: right;">
          <v-icon dark>add</v-icon>
          เพิ่มหน่วยงาน
        </v-btn>
        <v-btn v-if="tab == 1" class="mr-1" color="#84A2A8"
               @click="$router.push('/add-account').catch(err => {})"
               style="color: white;border-radius: 50px;text-align: right;">
          <v-icon dark>add</v-icon>
          เพิ่มบัญชีผู้ใช้งาน
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Tap Account All -->
    <template v-if="tab == 1">
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">ค้นหาข้อมูล : </span>
              <span>ชื่อผู้ใช้งาน</span>
            </v-flex>
            <v-flex mt-1 class="search-Data-Form">
              <v-text-field
                v-model="search_user"
                class="custom-placeholer-color"
                hide-details
                placeholder="ค้นหา"
                color="#ffffff"
                single-line
                outlined
                dark
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex>
            <v-flex mx-4>
              <v-btn @click="searchUser()" rounded>
                ค้นหา
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center class="table-search">
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headersAccount"
                :items="dataUser"
                :hide-default-footer="true"
              >
                <template v-slot:item.acc="{ item }">
                  <span style="text-decoration: underline;color: #D97C57;cursor: pointer;" @click="onEditAccount(item.noAcc)">แก้ไข/ลบ</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationAccount.last_page"
            :total-visible="9"
            @input="getPaginationAccount"
            v-model="paginationAccount.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </template>

    <!-- Tap Manage Department -->
    <template v-else>
      <v-layout>
        <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
          <v-layout>
            <v-flex shrink mr-4>
              <span style="font-size: 24px;font-weight: bold;">ค้นหาข้อมูล : </span>
              <span>ชื่อหน่วยงาน</span>
            </v-flex>
            <v-flex mt-1 class="search-Data-Form">
              <v-text-field
                v-model="search_organize"
                class="custom-placeholer-color"
                hide-details
                placeholder="ค้นหา"
                color="#ffffff"
                single-line
                outlined
                dark
                prepend-inner-icon="search"
              ></v-text-field>
            </v-flex>
            <v-flex mx-4>
              <v-btn @click="searchOrganization()" rounded>
                ค้นหา
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout justify-center class="table-search">
        <v-flex>
          <v-card>
            <template>
              <v-data-table
                :headers="headersManageDepartment"
                :items="dataOrganization"
                :hide-default-footer="true"
              >
                <template v-slot:item.id="{ item }">
                    <span style="text-decoration: underline;color: #D97C57;cursor: pointer;" @click="onEditDepartment(item.id)">แก้ไข/ลบ</span>
                </template>
              </v-data-table>
            </template>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout mt-4>
        <v-flex>
          <v-pagination
            :length="paginationOrganize.last_page"
            :total-visible="9"
            @input="getPaginationOrganize"
            v-model="paginationOrganize.current_page"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </template>


  </v-content>
</template>

<script>
    import Service from '../service'

    export default {
        name: "ManageUserAccounts",
        data: () => ({
            paginationAccount: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            paginationOrganize: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            organitzation: [],
            status:'ใช้งาน',
            tab: 1,
            // Manage User
            headersAccount: [
                {text: 'ชื่อ-นามสกุล', value: 'name', sortable: true, align: 'center',},
                {text: 'รหัสผู้ใช้งาน', value: 'noAcc', sortable: true, align: 'center',},
                {text: 'อีเมล', value: 'email', sortable: true, align: 'center',},
                {text: 'หมายเลขโทรศัพท์', value: 'no', sortable: true, align: 'center',},
                {text: 'หน่วยงาน', value: 'department', sortable: true, align: 'center',},
                {text: 'สถานะบัญชีผู้ใช้งาน', value: 'status', sortable: true, align: 'center',},
                {text: 'บัญชีผู้ใช้งาน', value: 'acc', sortable: true, align: 'center',},
            ],
            dataUser: [],
            search_user: '',

            // Manage Oranization
            headersManageDepartment: [
                {text: 'รหัสหน่วยงาน', value: 'noDepartment', sortable: true, align: 'center',},
                {text: 'ชื่อหน่วยงาน', value: 'nameDepartment', sortable: true, align: 'center',},
                {text: 'ชื่อสังกัด', value: 'nameMember', sortable: true, align: 'center',},
                {text: 'ที่ตั้งหน่วยงาน', value: 'locationDepartment', sortable: true, align: 'center',},
                {text: 'บัญชีหน่วยงาน', value: 'id', sortable: true, align: 'center',}
            ],
            dataOrganization: [],
            search_organize: '',

        }),
        created() {
            if(this.$route.query.activeTab !== undefined) {
                this.tab = this.$route.query.activeTab;
            }
            this.getAllUser();
            this.getOrganization();
        },
        methods: {
            onEditAccount(id) {
                this.$router.push(`/edit-and-delete-account/${id}`).catch(err => {});
            },
            onEditDepartment(id) {
                this.$router.push(`/edit-and-delete-department/${id}`).catch(err => {});
            },

            getAllUser() {
                Service.User.getAllUser(this.paginationAccount.current_page).then(res => {
                    // console.log(res)
                    res.data.forEach(user => {
                        this.dataUser.push({
                            name: `${user.firstname} ${user.lastname}`,
                            noAcc: `${user.id}`,
                            email: `${user.email}`,
                            no: `${user.tel}`,
                            department: `${user.organization.name}`,
                            status: user.status === '1' ? 'เปิดใช้งาน' : 'รอการยืนยัน',
                        });
                    })

                    this.paginationAccount.current_page = res.current_page;
                    this.paginationAccount.from = res.from;
                    this.paginationAccount.last_page = res.last_page;
                    this.paginationAccount.per_page = res.per_page;
                    this.paginationAccount.total = res.total;
                    this.paginationAccount.to = res.to;
                })
            },
            getOrganization() {
              Service.Organization.showOrganization(this.paginationOrganize.current_page).then(res => {
                  // console.log(res)
                  res.data.forEach(organization => {
                      this.dataOrganization.push({
                          noDepartment: `${organization.organize}`,
                          nameDepartment: `${organization.name}`,
                          nameMember: `${organization.party}`,
                          locationDepartment: `${organization.address}`,
                          id:`${organization.id}`
                      })
                  })
              })
            },
            searchUser() {
                // console.log(this.search_user)
                if(this.search_user === '') {
                    alert('กรุณากรอกคำที่ต้องการค้นหา')
                }else {
                    let data = {
                        word: this.search_user,
                        page: this.paginationAccount.current_page,
                    }
                    Service.User.searchUser(data).then(res => {
                        // console.log(res)
                        this.dataUser = [];
                        res.data.forEach(user => {
                            this.dataUser.push({
                                name: `${user.firstname} ${user.lastname}`,
                                noAcc: `${user.id}`,
                                email: `${user.email}`,
                                no: `${user.tel}`,
                                department: `${user.organize_name}`,
                                status: user.status === '1' ? 'เปิดใช้งาน' : 'รอการยืนยัน',
                            });
                        })
                    })
                }
            },
            searchOrganization() {
                // console.log(this.search_organize)
                if(this.search_organize === '') {
                    alert('กรุณากรอกคำที่ต้องการค้นหา')
                }else {
                    let data = {
                        word: this.search_user,
                        page: this.paginationAccount.current_page,
                    }
                    Service.User.searchOrganization(data).then(res => {
                        this.dataOrganization = [];
                        res.data.forEach(organization => {
                            this.dataOrganization.push({
                                noDepartment: `${organization.organize}`,
                                nameDepartment: `${organization.name}`,
                                nameMember: `${organization.party}`,
                                locationDepartment: `${organization.address}`,
                                id:`${organization.id}`
                            })
                        })
                    })
                }
            },

            // Pagination
            getPaginationAccount(page) {

                if (this.search_user === '') {
                    this.dataUser = [];
                    Service.User.getAllUser(page).then(res => {
                        res.data.forEach(user => {
                            this.dataUser.push({
                                name: `${user.firstname} ${user.lastname}`,
                                noAcc: `${user.id}`,
                                email: `${user.email}`,
                                no: `${user.tel}`,
                                department: `${user.organization.name}`,
                                status: user.status === '1' ? 'เปิดใช้งาน' : 'รอการยืนยัน',
                            });
                        })

                        this.paginationAccount.current_page = res.current_page;
                        this.paginationAccount.from = res.from;
                        this.paginationAccount.last_page = res.last_page;
                        this.paginationAccount.per_page = res.per_page;
                        this.paginationAccount.total = res.total;
                        this.paginationAccount.to = res.to;
                    })
                } else {
                    this.dataUser = [];
                    let data = {
                        word: this.search_user,
                        page: page,
                    }
                    Service.User.searchUser(data).then(res => {
                        // console.log('paginate', res)
                        res.data.forEach(user => {
                            this.dataUser.push({
                                name: `${user.firstname} ${user.lastname}`,
                                noAcc: `${user.id}`,
                                email: `${user.email}`,
                                no: `${user.tel}`,
                                department: `${user.organization.name}`,
                                status: user.status === '1' ? 'เปิดใช้งาน' : 'รอการยืนยัน',
                            });
                        })

                        this.paginationAccount.current_page = res.current_page;
                        this.paginationAccount.from = res.from;
                        this.paginationAccount.last_page = res.last_page;
                        this.paginationAccount.per_page = res.per_page;
                        this.paginationAccount.total = res.total;
                        this.paginationAccount.to = res.to;
                    })
                }

            },
            getPaginationOrganize(page) {
                // console.log(page)
                if (this.search_organize === '') {
                    this.dataOrganization = [];
                    Service.Organization.showOrganization(page).then(res => {
                        // console.log(res)
                        res.data.forEach(organization => {
                            this.dataOrganization.push({
                                noDepartment: `${organization.organize}`,
                                nameDepartment: `${organization.name}`,
                                nameMember: `${organization.party}`,
                                locationDepartment: `${organization.address}`,
                                id:`${organization.id}`
                            })
                        })
                    })
                } else {
                    let data = {
                        word: this.search_user,
                        page: page,
                    }
                    Service.User.searchOrganization(data).then(res => {
                        // console.log(res)
                        this.dataOrganization = [];
                        res.data.forEach(organization => {
                            this.dataOrganization.push({
                                noDepartment: `${organization.organize}`,
                                nameDepartment: `${organization.name}`,
                                nameMember: `${organization.party}`,
                                locationDepartment: `${organization.address}`,
                                id:`${organization.id}`
                            })
                        })
                    })
                }
            }
        }
    }
</script>

<style lang="scss">
  /*.search-account {*/
  /*  .v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width > .v-input__control > .v-input__slot, .v-text-field--outlined > .v-input__control > .v-input__slot {*/
  /*    min-height: unset !important;*/

  /*  }*/

  /*  label.v-label.theme--light {*/
  /*    position: unset !important;*/
  /*  }*/

  /*  .v-text-field .v-label {*/
  /*    text-overflow: unset;*/
  /*    overflow: unset;*/
  /*  }*/

  /*  .v-text-field--outlined .v-input__control, .v-text-field--outlined .v-input__slot, .v-text-field--outlined fieldset, .v-text-field--solo .v-input__control, .v-text-field--solo .v-input__slot, .v-text-field--solo fieldset {*/
  /*    border-radius: 100px;*/
  /*  }*/

  /*  .theme--light.v-text-field--outlined fieldset {*/
  /*    border-color: white;*/
  /*  }*/

  /*  .custom-placeholer-color input::placeholder {*/
  /*    color: white !important;*/
  /*  }*/

  /*  .v-text-field.v-text-field--enclosed .v-input__append-inner, .v-text-field.v-text-field--enclosed .v-input__append-outer, .v-text-field.v-text-field--enclosed .v-input__prepend-inner, .v-text-field.v-text-field--enclosed .v-input__prepend-outer {*/
  /*    margin-top: 4px;*/
  /*  }*/
  /*}*/
  /*//กำหนดสีขอบตาราง*/
  /*th.text-center {*/
  /*  background: #527281;*/
  /*  color: white !important;*/
  /*  font-size: 14px !important;*/
  /*}*/
  /*//กำหนดสีขอบตาราง*/
  /*th.text-center:not(:last-child) {*/
  /*  border-right-style: solid;*/
  /*  border-color: white;*/
  /*  border-width: 1px;*/
  /*}*/

  /*.v-data-table td, .v-data-table th {*/
  /*  padding: 0 4px !important;*/
  /*}*/

  /*.button-taps {*/
  /*  button.mr-1.v-btn.v-btn--contained.theme--light.v-size--default.active {*/
  /*    background-color: #527281;*/
  /*  }*/
  /*  button.mr-1.v-btn.v-btn--contained.theme--light.v-size--default {*/
  /*    background-color: #BDBDBD;*/
  /*  }*/
  /*}*/
</style>
